import type { BrandKit } from '@/lib/api/types';

/**
 * Baseline brand kit used as the initial form state in the Brand Identity
 * editor before the saved kit loads (and as the merge base for partial data).
 */
export const DEFAULT_BRAND_KIT: BrandKit = {
  campaignName: 'Demo Campaign',
  primaryColor: '#1A1A2E',
  secondaryColor: '#C8E530',
  font: 'Inter',
  clientLogo: null,
  brandLogo: null,
  backgroundImage: null,
  language: 'en',
  collectData: true,
  collectName: true,
  collectEmail: true,
  collectPhone: false,
  ageGate: 'none',
  demoAge: true,
  demoGender: true,
  demoEthnicity: false,
  demoNationality: false,
  gameMechanic: 'wheel',
  celebrationTheme: 'confetti',
};
